import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        event: '=',
        courses: '='
    },
    template: `
    <div class="heading01 type01">
        <h1>{{ 'events.Create new notification rule' | translate }}</h1>
        <a ui-sref="authorized.events.list()" class="btn discrete">{{ 'general.Back to list' | translate }}</a>
    </div>
    <events-partials-detail
        courses="vm.courses"
        event="vm.event"
        context="vm.context"
    />
</div>

    `
})
export default class {
    constructor () {
        this.context = 'add';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/events/add/index.js